import {GraphicRef, GraphicType, IGraphic} from '@mintdata/mint-kit/api/assets/Graphic';

export class Illustration2 implements IGraphic
{
    constructor(public name:string,
                public label:string,
                public tags:string[],
                public svg:string)
    {
    }

    public getType():GraphicType
    {
        return GraphicType.Illustration2;
    }

    public getRef():GraphicRef
    {
        return new GraphicRef(this.name, this.getType());
    }
}
